export class ProjectAndAdminInfo {
  id: String;
  name: String;
  company_name: String;
  contact_info: String;
  dob: String | null;
  email: String;
  firstname: String;
  gender: String;
  lastname: String;
  phone_no: String;
  profile_image_actual_filename: String;
  profile_image_filename: String;
  username: String;
  project_manager_id: String;

  constructor() {
    this.id = '';
    this.name = '';
    this.company_name = '';
    this.contact_info = '';
    this.dob = '';
    this.email = '';
    this.firstname = '';
    this.gender = '';
    this.lastname = '';
    this.phone_no = '';
    this.profile_image_actual_filename = '';
    this.profile_image_filename = '';
    this.username = '';
    this.project_manager_id = '';
  }
}
